const WAREHOUSE_FIELD_LABELS = {
  code: '代號',
  name: '名稱',
  remark: '備註',
};

const WAREHOUSE_LOCATION_FIELD_LABELS = {
  warehouseId: '倉別',
  code: '代號',
  name: '名稱',
  remark: '備註',
};

export {
  WAREHOUSE_FIELD_LABELS,
  WAREHOUSE_LOCATION_FIELD_LABELS,
};
